module.exports = __webpack_public_path__ + "img/ergLogo4@2x.558019d7.jpg";